import React from 'react';
import { useDispatch } from 'react-redux';
import * as Route from '../../main/utils/serverRoutes';
import { UserCard } from './user/UserCard';
import makeRequest from '../../main/utils/makeRequest';

const UserSelect = ({ locales, users }) => {
  const dispatch = useDispatch();

  const loginAsUser = (userId) => {
    console.log(userId);
    makeRequest({
      url: Route.ssoUserChoice(userId),
      method: 'POST',
      success: (response) => {
        if (response.status === 200) {
          window.location.href = response.data.redirectTo;
        }
      },
      dispatch,
    });
  };

  const renderUsers = () => {
    return users.map((user, i) => {
      return (
        <UserCard
          key={i}
          locales={locales}
          user={user}
          loginAsUser={loginAsUser}
        />
      );
    });
  };

  return (
    <>
      <div className="sign-up-form__title-sm">{locales.sso.selectAccount}</div>
      <div className="sign-up-form sso-user-card-container">
        {renderUsers()}
      </div>
    </>
  );
};

export default UserSelect;
